import { PlanCard } from './styles';
import { PlanCardHeaderV2 } from './PlanCardHeader';
import { PlanCardBodyV2 } from './PlanCardBody';
export const PlanCardV2 = ({ data }: any) => {
  return (
    <>
      <PlanCard>
        <PlanCardHeaderV2
          header={data.header}
          cost={data.cost}
          secondHeader={data.secondHeader}
          hasFreeButton={data.hasFreeButton}
        />
        <PlanCardBodyV2 list={data.list} additionalSection={data.additionalSection} />
      </PlanCard>
    </>
  );
};
